import {TemperatureUnit} from '@/common/constants/units';
import {temperatureReduce} from './temperatureReduce';

const unitDisplayName: Record<TemperatureUnit, string> = {
	[TemperatureUnit.celsius]: 'C',
	[TemperatureUnit.fahrenheit]: 'F',
};

export function temperatureDisplayReduce(celsiusValue: number, unit: TemperatureUnit, includeInit = false) {
	const value = temperatureReduce(celsiusValue, unit);
	const sign = value > 0 ? '+' : '';
	const unitName = includeInit ? unitDisplayName[unit] : '';

	return `${sign}${value}°${unitName}`;
}
